import MABackgroundImage from "../../../../src/assets/images/missionapps1.png";
import BCLogo from "../../../../src/assets/images/bclogo_notext.svg";
import * as React from 'react';
export default {
  MABackgroundImage,
  BCLogo,
  React
};